<template>
  <transition name="slide-fade" mode="out-in">
    <div class="flex">
      <answer-select ref="answerSuggestionSelect"
                     :answer-options="answers"
                     :first-request="formData.firstRequest"
                     :intent-platform-id="suggestedIntentPlatformId"
                     :answer-name="suggestedAnswerName"
                     :tabindex="3"
                     :show-add-new-answer="true"
                     :key="formData.messageId + answers.length"
                     :error-message="errorMessage"
                     class="w-full"
                     @change-answer="changeSuggestedAnswer"
                     @blur="$emit('answer-select-blur')"
      />
      <dropdown-button :name="suggestButtonId"
                       :options="buttonOptions"
                       dropdown-position="below-right"
                       :is-split-button="true"
                       :is-busy="isBusy"
                       :label="selectedButton.title"
                       primary-button-variant="primary-grouped"
                       primary-button-classes="h-12"
                       @select-button="$emit('select-button', $event)"
                       @trigger-action="$emit('suggest-answer')"
      />
    </div>
  </transition>
</template>

<script>
import AnswerSelect from '@/components/analytics/conversations/detail/AnswerSelect.vue'
import DropdownButton from '@/components/common/DropdownButton.vue'
import busyButtonsModule from '@/store/modules/busy-buttons.module'
import dropdownButtonsUtils from '@/utils/dropdown-button.utils'

export default {
  name: 'AnswerSuggestionFormControl',

  components: {
    AnswerSelect,
    DropdownButton
  },

  props: {
    answers: {
      type: Array,
      default: () => []
    },
    formData: {
      type: Object,
      default: () => {}
    },
    suggestedIntentPlatformId: {
      type: String,
      default: ''
    },
    suggestedAnswerName: {
      type: String,
      default: ''
    },
    isSelectOpen: {
      type: Boolean,
      default: false
    },
    suggestButtonId: {
      type: String,
      default: ''
    },
    selectedButton: {
      type: Object,
      default: () => {}
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },

  computed: {
    isBusy() {
      return busyButtonsModule.isButtonBusy(this.suggestButtonId)
    },

    buttonOptions() {
      return dropdownButtonsUtils.getSuggestAnswerOptions()
    }
  },

  methods: {
    changeSuggestedAnswer(e) {
      this.$emit('change-suggested-answer',
        { suggestedIntentPlatformId: e.intentPlatformId, suggestedAnswerName: e.answerName }
      )
    }
  },

  watch: {
    selectedButton: {
      immediate: false,
      handler() {
        if (this.suggestedAnswerName) return

        this.$refs.answerSuggestionSelect.focusOnAnswerSelect()
      }
    }
  }
}
</script>
